/// <reference types="@angular/localize" />

import { enableProdMode } from '@angular/core';

import { platformBrowser } from '@angular/platform-browser';
import { polyfillCountryFlagEmojis } from 'country-flag-emoji-polyfill';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// Chrome e Edge no Windows não desenham emoji de bandeira nativamente (mostram "BR", "US").
// A fonte vem do próprio app (copiada do pacote no angular.json), não do CDN padrão do
// polyfill: rede corporativa que bloqueia o jsDelivr voltaria a mostrar "BR".
polyfillCountryFlagEmojis('Twemoji Country Flags', 'assets/fonts/TwemojiCountryFlags.woff2');

platformBrowser()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
